// extracted by mini-css-extract-plugin
module.exports = {"profilePageWrapper":"SelectedCompanyProfilePage_profilePageWrapper__2Hih8"};